import { render, staticRenderFns } from "./BadgeCount.vue?vue&type=template&id=28bdbc1c&scoped=true"
import script from "./BadgeCount.vue?vue&type=script&lang=js"
export * from "./BadgeCount.vue?vue&type=script&lang=js"
import style0 from "./BadgeCount.vue?vue&type=style&index=0&id=28bdbc1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bdbc1c",
  null
  
)

export default component.exports